import { render, staticRenderFns } from "./MediaInventoriesModal.vue?vue&type=template&id=cdb5a774"
import script from "./MediaInventoriesModal.vue?vue&type=script&lang=js"
export * from "./MediaInventoriesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports